import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

type QueryParamsMap = Record<string, string | null>;

export const useQueryParams = (
  paramNames: string[],
  onChange?: (params: QueryParamsMap) => void
) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Extract current values of specified params
  const getParams = (): QueryParamsMap => {
    const searchParams = new URLSearchParams(location.search);
    const result: QueryParamsMap = {};
    paramNames.forEach((key) => {
      result[key] = searchParams.get(key);
    });
    return result;
  };

  // Trigger effect when params change
  useEffect(() => {
    if (onChange) {
      onChange(getParams());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, paramNames.join(",")]);

  // Update one or more query params in the URL
  const setParams = (updates: Record<string, string | null>) => {
    const searchParams = new URLSearchParams(location.search);

    for (const key in updates) {
      const value = updates[key];
      if (value === null || value === undefined) {
        searchParams.delete(key);
      } else {
        searchParams.set(key, value);
      }
    }

    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  return {
    params: getParams(),
    setParams,
  };
};
